import React, { useState } from 'react'
import { Box, Tab, Tabs } from '@mui/material'
import GenerateVoucherTab from './GenerateVoucherTab'
import CreditVoucherTab from './CreditVoucherTab'
import VoucherReports from './VoucherReports'
import { Item } from '../../../../common/snippets'
import { useTranslation } from '../../../../../i18n/I18nProvider'

const PartyVoucherPage = () => {
    const { translations } = useTranslation()
    const rdcn = translations?.rechargeDebitCreditNote || {}
    const senderSect = [
        rdcn.generateVoucher || 'Generate Voucher',
        rdcn.creditVoucher || 'Credit Voucher',
        rdcn.voucherReports || 'Voucher Reports',
    ]
    const [senderSectContent, setSenderSectContent] = useState(0)

    const handleSenderSect = (event, newValue) => {
        setSenderSectContent(newValue)
    }
    function a11yProps(index) {
        return {
            id: `simple-tab-${index}`,
            'aria-controls': `simple-tabpanel-${index}`,
        }
    }

    return (
        <>
            <Item
                sx={{
                    width: '100%',
                    margintTop: '10px',
                    padding: '0px',
                    paddingLeft:'17px'
                    //   paddingLeft: '19px',
                    //  marginRight: '25px',
                }}
            >
                <Box sx={{ borderBottom: 1, borderColor: 'divider' }}>
                    <Tabs value={senderSectContent} onChange={handleSenderSect} aria-label="bsic tabs example">
                        {senderSect.map((reqType, index) => (
                            <Tab key={`sender_${index}`} label={reqType} {...a11yProps(index)} style={{ lineHeight: '2.5' }} />
                        ))}
                    </Tabs>
                </Box>
            </Item>
            {senderSectContent === 0 ? <GenerateVoucherTab /> : ''}
            {senderSectContent === 1 ? <CreditVoucherTab /> : ''}
            {senderSectContent === 2 ? <VoucherReports /> : ''}
        </>
    )
}

export default PartyVoucherPage
